import { OWNERS_FETCH_SUCCEEDED, OWNERS_FETCH_STARTED } from './ActionTypes';
import { fetchOwners } from '../api/ownersApi';
import { arrayToMap } from '../utils/mapperUtil';
export function getOwners() {
  return dispatch => {
    dispatch({
      type: OWNERS_FETCH_STARTED
    });
    return fetchOwners().then(data => {
      const ownersMap = arrayToMap(data, 'userIdIncludingInactive');
      dispatch({
        type: OWNERS_FETCH_SUCCEEDED,
        payload: ownersMap
      });
      return data;
    });
  };
}